if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantIdInput = this.variantIdInput;
        if (variantIdInput) {
          variantIdInput.disabled = false;
        }

        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.loadingSpinner = this.querySelector('.loading__spinner');

        if (!this.submitButton) return;

        this.submitButtonText = this.submitButton.querySelector('span');

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        if (this.cart) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender === 'function'
        ) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors:
                  response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                'true'
              );

              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (
              !this.cart ||
              typeof this.cart.renderContents !== 'function'
            ) {
              window.location = window.routes.cart_url;
              return;
            }

            let startMarker;

            if (
              typeof CartPerformance !== 'undefined' &&
              typeof CartPerformance.createStartingMarker ===
                'function'
            ) {
              startMarker =
                CartPerformance.createStartingMarker(
                  'add:wait-for-subscribers'
                );
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            if (
              startMarker &&
              typeof CartPerformance !== 'undefined'
            ) {
              CartPerformance.measureFromMarker(
                'add:wait-for-subscribers',
                startMarker
              );
            }

            this.error = false;

            const renderCart = () => {
              if (
                typeof CartPerformance !== 'undefined' &&
                typeof CartPerformance.measure === 'function'
              ) {
                CartPerformance.measure(
                  'add:paint-updated-sections',
                  () => {
                    this.cart.renderContents(response);
                  }
                );
              } else {
                this.cart.renderContents(response);
              }
            };

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(renderCart);
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              renderCart();
            }
          })
          .catch((error) => {
            console.error(
              'Add-to-cart request failed:',
              error
            );

            this.handleErrorMessage(
              'Unable to add this product to the cart. Please try again.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (this.loadingSpinner) {
              this.loadingSpinner.classList.add('hidden');
            }

            if (
              typeof CartPerformance !== 'undefined' &&
              typeof CartPerformance.measureFromEvent ===
                'function'
            ) {
              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form
          ? this.form.querySelector('[name="id"]')
          : null;
      }
    }
  );
}